import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

import RadioList from '../RadioList/RadioList';
import CollectionDropdownBtn from '../CollectionDropdownBtn/CollectionDropdownBtn';
import AddToCartBtn from '../AddToCartBtn/AddToCartBtn';
import CollectionBtnModal from '../CollectionBtnModal/CollectionBtnModal';
import { doesSelectedVariantExist } from '../../Utils/VariantUtils';
import { StyledDiv } from './CollectionBtnWrapperStyles';

var CollectionBtnWrapper = function CollectionBtnWrapper(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownActive = _useState2[0],
      setDropdownActive = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showDropdownOption = _useState4[0],
      setShowDropdownOption = _useState4[1];

  var handleBtnWrapperEnter = function handleBtnWrapperEnter() {
    // on mouse enter, show selected option
    setShowDropdownOption(true);
    props.handleCollectionBtnWrapperEnter();
  };

  var handleDropdownBtnEnter = function handleDropdownBtnEnter() {
    // on mouse enter, open dropdown
    setDropdownActive(true);
  };

  var handleDropdownBtnLeave = function handleDropdownBtnLeave() {
    // on mouse leave, close dropdown
    setDropdownActive(false);
  };

  useEffect(function () {
    // if options change, close dropdown
    setDropdownActive(false);
  }, [props.selectedVariant]);

  var variantExists = doesSelectedVariantExist(props.selectedOptions, props.selectedVariant);

  var useDropdown = props.dropdownOption != null;

  var buttonDisabled = !props.selectedVariant.availableForSale || !variantExists;

  return React.createElement(
    StyledDiv,
    {
      onMouseEnter: useDropdown ? handleBtnWrapperEnter : null,
      onMouseLeave: useDropdown ? handleDropdownBtnLeave : null
    },
    useDropdown && React.createElement(CollectionDropdownBtn, {
      dropdownActive: dropdownActive,
      btnDisabled: buttonDisabled,
      handleDropdownBtnEnter: handleDropdownBtnEnter,
      selectedOptions: props.selectedOptions,
      option: props.dropdownOption,
      selectedVariantAvailable: props.selectedVariant.availableForSale,
      showDropdownOption: showDropdownOption
    }),
    React.createElement(AddToCartBtn, {
      selectedVariantQuantity: props.selectedVariantQuantity,
      addVariantToCart: props.addVariantToCart,
      customCollection: props.customCollection,
      collectionTitle: props.collectionTitle,
      product: props.product,
      selectedVariantId: props.selectedVariant.id,
      variantExists: variantExists,
      selectedVariantAvailable: props.selectedVariant.availableForSale,
      useDropdown: useDropdown,
      btnStyle: 'COLLECTION',
      ineligibleForDiscount: props.product.tags.includes('data--no_coupon:1')
    }),
    useDropdown && React.createElement(
      Fragment,
      null,
      React.createElement(RadioList, {
        handleOptionChange: props.handleOptionChange,
        productId: props.product.id,
        option: props.dropdownOption,
        selectedOptions: props.selectedOptions,
        selectedVariant: props.selectedVariant,
        variants: props.variants,
        dropdownActive: dropdownActive,
        useDropdown: useDropdown
      }),
      React.createElement(CollectionBtnModal, {
        product: props.product,
        openProductModal: props.openProductModal
      })
    )
  );
};

CollectionBtnWrapper.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  handleOptionChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  product: PropTypes.object.isRequired,
  selectedOptions: PropTypes.object.isRequired,
  selectedVariant: PropTypes.object.isRequired,
  selectedVariantQuantity: PropTypes.number.isRequired,
  variants: PropTypes.array.isRequired,
  collectionTitle: PropTypes.string,
  dropdownOption: PropTypes.object,
  handleCollectionBtnWrapperEnter: PropTypes.func,
  customCollection: PropTypes.bool,
  openProductModal: PropTypes.func
};

export default CollectionBtnWrapper;